import type { Colors, DefaultTheme } from 'styled-components';
import { setAlpha } from '../utils';
import { lightColors, mapLightTheme } from './LightTheme';

const colors: Colors = {
  ...lightColors,
  green: {
    default: '#0e9874',
    lighten: '#20a884',
    dim: setAlpha(0.4, '#0e9874'),
    mute: setAlpha(0.1, '#0e9874'),
  },
  red: {
    default: '#922E43',
    lighten: '#e84d72',
    dim: setAlpha(0.4, '#922E43'),
    mute: setAlpha(0.1, '#922E43'),
  },
  blue: {
    default: '#CCAC3E',
    lighten: '#499ef6',
    dim: setAlpha(0.4, '#CCAC3E'),
    mute: setAlpha(0.1, '#CCAC3E'),
  },
  primary: {
    default: '#1F3D66',
    lighten: '#26528d',
    dim: setAlpha(0.4, '#1F3D66'),
    mute: setAlpha(0.1, '#1F3D66'),
  },
};

export const LightCelsionTheme: DefaultTheme = mapLightTheme(colors, {
  name: 'LightCl',

  backgroundChartUpColor: colors.green.lighten,
  backgroundChartDownColor: colors.red.lighten,
  borderColorChartUpColor: colors.green.lighten,
  borderColorChartDownColor: colors.red.lighten,
});
